import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NormalizedV2Response } from '@/types/eds/api/responses/NormalizedV2Response';
import { GetNoteListPayload, GetNotesResponse, NoteEntities } from '@/domains/notes/store/types/noteTypes';
import { noteInitialState } from '@/domains/notes/store/constants/noteSliceConstants';

const noteSlice = createSlice({
  name: 'notes',
  initialState: noteInitialState,
  reducers: {
    getNoteList: (_, _action: PayloadAction<GetNoteListPayload>) => {},
    incrementNotePage: (state, _action: PayloadAction<GetNoteListPayload>) => {
      state.data.pagination.page++;
    },
    getNoteListSuccess: (
      state,
      { payload: { shouldRewrite = true, data } }: PayloadAction<{ shouldRewrite?: boolean; data: GetNotesResponse }>,
    ) => {
      const listingsArray = Array.isArray(data.listings) ? data.listings : [data.listings];

      if (shouldRewrite) {
        state.data.listings = [...listingsArray];
        state.data.pagination = data.pagination;
      } else {
        state.data.listings = [...state.data.listings, ...listingsArray];
        state.data.pagination = data.pagination;
      }

      state.statuses.isLoading = false;
    },
    startLoadingNoteListData: (state) => {
      state.statuses.isLoading = true;
    },
    setNoteOptionsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isLoading = payload;
    },
    resetNoteSlice: () => noteInitialState,
    getEntitiesFromClaimSet: (_, _action: PayloadAction<string>) => {},
    getEntitiesFromClaimSetSuccess: (state, { payload }: PayloadAction<NoteEntities[]>) => {
      state.noteEntities = payload;
    },
    markNoteAsRead: (_state, _payload: PayloadAction<number>) => {},
    markNoteAsUnread: (_state, _payload: PayloadAction<number>) => {},
    setNoteUpdateInProgress: (state, { payload }: PayloadAction<{ noteId: number; value: boolean }>) => {
      state.statuses.noteUpdateInProgress[payload.noteId] = payload.value;
    },
    refreshNote: (_state, _payload: PayloadAction<number>) => {},
    refreshNoteSuccess: (state, action: PayloadAction<NormalizedV2Response>) => {
      state.data.listings = state.data.listings.map((note) => (note.id === action.payload.id ? action.payload : note));
    },
    getNoteReminder: (_, _action: PayloadAction<number[]>) => {},
    getNoteReminderSuccess: (state, { payload: { reminders } }: PayloadAction<{ reminders: GetNotesResponse }>) => {
      const listingsArray = Array.isArray(reminders.listings) ? reminders.listings : [reminders.listings];

      state.reminders.listings = [...listingsArray];
      state.reminders.pagination = reminders.pagination;
    },
    deleteNote: (_state, _payload: PayloadAction<number>) => {},
  },
});

export const {
  getNoteList,
  getNoteListSuccess,
  startLoadingNoteListData,
  incrementNotePage,
  setNoteOptionsLoading,
  resetNoteSlice,
  getEntitiesFromClaimSet,
  getEntitiesFromClaimSetSuccess,
  markNoteAsRead,
  markNoteAsUnread,
  refreshNote,
  refreshNoteSuccess,
  getNoteReminder,
  getNoteReminderSuccess,
  deleteNote,
  setNoteUpdateInProgress,
} = noteSlice.actions;

export const noteReducer = noteSlice.reducer;
export const noteReducerPath = noteSlice.reducerPath;
